import { Button, Modal, Form, Flex, Typography, message, Radio } from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
} from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
const OffModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [currentRecord, setCurrentRecord] = useState(null);
  const [visible, setVisible] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [enabledValue, setEnabledValue] = useState(null);

  useImperativeHandle(ref, () => ({
    showModal: async (record) => {
      try {
        setCurrentRecord(record);
        const initValue = record?.enabled ? "ON" : "OFF";
        setEnabledValue(initValue);
        form.setFieldsValue({ enabled: initValue });
        setVisible(true);
      } catch (error) {
        message.error("Failed to initialize modal");
      }
    },
  }));

  const handleUpdateRoleSubmit = async (values) => {
    try {
      setTableLoading(true);
      const params = {
        id: currentRecord.id,
        enabled: values.enabled === "ON" ? 1 : 0,
      };
      const response = await http.get(api.getEnable, { params });
      if (response.code === "1") {
        message.success("Successfully.");
        onSuccess?.();
        handleClose();
      } else {
        message.error("Operation failed.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setTableLoading(false);
    }
  };


  const handleClose = () => {
    setVisible(false);
    setEnabledValue(null);
    form.resetFields();
    setCurrentRecord(null);
  };

  return (
    <Modal
      title="Turn On/Off Scheduled Tasks"
      width="40%"
      open={visible}
      onCancel={handleClose}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button key="back" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={tableLoading}
          onClick={() => form.submit()} 
        >
          Submit
        </Button>
      </div>}
    >
           <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
          <Form
        form={form}
        name="AddForm"
        onFinish={handleUpdateRoleSubmit}
        labelCol={{ style: { width: "150px" } }}
        wrapperCol={{ style: { flex: 1 } }}
      >
        <Form.Item
          name="enabled"
          label="Enabled"
          rules={[{ required: true, message: "Please select enabled status" }]}
        >
          <Radio.Group
            value={enabledValue}
            onChange={(e) => {
              setEnabledValue(e.target.value);
              form.setFieldsValue({ enabled: e.target.value }); 
            }}
          >
            <Radio value="ON">ON</Radio>
            <Radio value="OFF">OFF</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
          </div>
        </div>
      </Flex>
    
    </Modal>
  );
});

export default OffModal;